<template>
     <div>
  
       <!-- <mheader></mheader> -->
        <div v-show="list.length>0" class="card mb-5 p-2" id="v-content" :style="{minHeight:Height+'px'}" style="width:1300px;margin:0 auto;box-shadow: 10px 10px 5px #888888;">
          <p>
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                </span>
          </p>
          <div v-for="(item,index) in list" :key="index" style="margin-top:70px;">
              <div v-if="id==item._id.$oid">
                <p class="text-center mt-2 mb-3" style="font-size:25px;">{{item.articleName}}
                </p>
                <div v-html="item.content" style="text-indent:30px;line-height:40px;">
                    {{item.content}}
                </div>
                <p class="text-right">{{item.author}}</p>
                <p class="text-right">{{item.checker}}</p>
                <!-- <p>{{item.source}}</p> -->
                <!-- <p>{{item.state}}</p> -->
                <!-- <p>{{item.stick}}</p> -->
              </div>
          </div>
        </div>
  
      <div>
              <transition name="fade">
                <loading v-if="isLoading"></loading>
              </transition>
      </div>
   <!-- <mfooter></mfooter> -->
  
     </div>
</template>
<script>
// import mheader from '../components/Header.vue'
// import mfooter from '../components/Footer.vue'
import Loading from '../components/Loading.vue'
export default {
  name:'myM',
  data(){
    return {
            Height:0,
          isLoading:false,
          list:[],
          id:'',
    }
  },
   components:{
        // mheader,
        // mfooter,
        Loading

    },
    methods:{
     getMR: async function () {
        //  this.isLoading=true;
        const {data: res} = await this.$http.post('http://192.168.1.215:8088/Home/getMR', 
          {groupid:window.sessionStorage.getItem("groupid")}
        )
        // console.log(res)
        if (res.isOk) {
             let that=this;
             that.list=res.mesg;
            //  that.isLoading=false;
             
        }
      },
      getId(){
           this.id=this.$route.query.id
      }
    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
    created(){
      this.getId();
      this.getMR();
    }
  
}
</script>
<style scoped>
  .span_close:hover{
        color:#36d;
  }

</style>



// WEBPACK FOOTER //
// src/pages/MyM.vue